export enum Buyer {
    Unspecified,
    Cosigned,
    Buyer
}